import { BasicFilters } from ".."
import { AgreementStatus } from "../agreements/agreement";
import { DeathData } from "../deathData/deathData"

export interface ParcelData {
  parcelId: string;
}

export const PARCEL_SECTIONS = [
  "A0", "A1",
  "B0", "B1",
  "C0",
  "D0", "D1",
  "E0", "E1",
  "F0", "F1",
  "I0", "I1",
  "J0",
  "K0", "K1",
  "M0",
  "N0", "N1"
];

export enum SellCode {
  URGENCY = 'U',
  PRENECESSITY = 'P',
  TRANSFER = 'T'
}

export enum ExpensesCode {
  IN_USE = 'U',
  PERPETUITY = 'S',
  OTHER = 'N',
  URNS = 'B'
}

export enum ParcelState {
  AVAILABLE = 'available',
  SOLD = 'sold',
  OCCUPIED = 'occupied',
  RESERVED = 'reserved',
  NOT_AVAILABLE = 'not_available'
}

export enum ParcelContractState {
  INHERITED = 'inherited',
  EXHUMATED = 'exhumated',
  SUSPENDED = 'suspended'
}

export interface Parcel {
  id: string
  fila: number
  parcela: number
  section: string
  state: ParcelState
  contractId: string | null
  contractNumber: string | null
  parcelContractState: ParcelContractState
  sellCode: string | null
  expensesCode: string | null
  outstandingAmount: number
  createdAt: string
  updatedAt: string
  createdBy: string | null
  updatedBy: string | null
  ownerName?: string
  deceasedNames?: string
}

export interface ParcelContractEvent {
  id: string;
  parcelContractId: string;
  eventType: string;
  eventDate: Date;
  deathName: string;
  createdAt: Date;
  createdBy: string | null;
  payload?: any;
}

export interface ParcelContractDetail {
  id: string,
  contractId: string,
  parcelId: string,
  sellCode?: string | null,
  expensesCode?: ExpensesCode,
  section: string,
  fila: number,
  parcela: number,
  parcelState: ParcelState,
  contractNumber: string | null,
  parcelContractState?: ParcelContractState,
  clientId: string,
  deathData?: DeathData[],
  events?: ParcelContractEvent[]
  createdAt: string,
  updatedAt: string,
  createdBy: string | null,
  updatedBy: string | null,
}

export interface ParcelFilters extends BasicFilters {
  section?: string,
  fila?: string,
  parcela?: string,
  state?: ParcelState,
  contractId?: string,
  sellCode?: string,
  expensesCode?: string,
  userId?: string,
}

export const getParcelStateColor = (state: ParcelState, parcelContractState?: ParcelContractState | null) => {
  if (parcelContractState === ParcelContractState.EXHUMATED) {
    return 'bg-orange-100 text-orange-800 hover:bg-orange-100'
  }
  else if (parcelContractState === ParcelContractState.SUSPENDED) {
    return 'bg-red-100 text-red-800 hover:bg-red-100'
  }
  switch (state) {
    case ParcelState.AVAILABLE:
      return 'bg-green-100 text-green-800 hover:bg-green-100'
    case ParcelState.SOLD:
      return 'bg-blue-100 text-blue-800 hover:bg-blue-100'
    case ParcelState.OCCUPIED:
      return 'bg-purple-100 text-purple-800 hover:bg-purple-100'
    case ParcelState.RESERVED:
      return 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100'
    case ParcelState.NOT_AVAILABLE:
      return 'bg-red-100 text-red-800 hover:bg-red-100'
    default:
      return 'bg-gray-100 text-gray-800'
  }
}

export const formatParcelState = (state: ParcelState, parcelContractState?: ParcelContractState | null) => {
  if (parcelContractState === ParcelContractState.EXHUMATED) {
    return 'Exhumada'
  }
  else if (parcelContractState === ParcelContractState.SUSPENDED) {
    return 'Suspendida'
  }
  switch (state) {
    case ParcelState.AVAILABLE: return 'Disponible'
    case ParcelState.SOLD: return 'Vendida'
    case ParcelState.OCCUPIED: return 'Ocupada'
    case ParcelState.RESERVED: return 'Reservada'
    case ParcelState.NOT_AVAILABLE: return 'No Disponible'
    default: return state
  }
}

export const formatSellCode = (code?: string) => {
  if (!code) return '-'
  switch (code) {
    case 'U': return 'Urgencia'
    case 'P': return 'Prenecesidad'
    case 'T': return 'Traslado'
    default: return code
  }
}

export const formatExpensesCode = (code?: string) => {
  if (!code) return '-'
  switch (code) {
    case 'U': return 'En uso'
    case 'S': return 'Perpetuidad'
    case 'N': return 'N'
    case 'B': return 'Urna cineraria'
    default: return code
  }
}

